export const providerSupportAddress = "providersupport@ameelio.org";
export const visitorSupportAddress = "customersupport@ameelio.org";
export const accessibilitySupportAddress = "accessibility@ameelio.org";
